export const environment = {
  production: false,
  appTitle: 'پیشخوان تامین کنندگان',
  siteAddress: 'https://yadzar.com',
  apiUrl: 'https://api.yadzar.com/v1',
  imageUrl: 'https://api.yadzar.com/media/',
  firebase: {
    apiKey: "AIzaSyBHhXpwB5lZkv6yjq1xPo1DaYRD1WnMm-Q",
    authDomain: "2015.firebaseapp.com",
    projectId: "2015",
    storageBucket: "2015.appspot.com",
    messagingSenderId: "605275400385",
    appId: "1:605275400385:web:dd8e669b165210af2a0c40",
    measurementId: "G-CKTERRSNPX"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
